/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Gym_Name_Too_LongInputs */

const en_us2_gym_name_too_long = /** @type {(inputs: Gym_Name_Too_LongInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Keep the name under ${i?.max} characters.`)
};

const pt_br2_gym_name_too_long = /** @type {(inputs: Gym_Name_Too_LongInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Use um nome com menos de ${i?.max} caracteres.`)
};

const es_419_gym_name_too_long = /** @type {(inputs: Gym_Name_Too_LongInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Usa un nombre de menos de ${i?.max} caracteres.`)
};

const pt_pt2_gym_name_too_long = /** @type {(inputs: Gym_Name_Too_LongInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Usa um nome com menos de ${i?.max} caracteres.`)
};

const fr_fr2_gym_name_too_long = /** @type {(inputs: Gym_Name_Too_LongInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Le nom doit faire moins de ${i?.max} caractères.`)
};

const de_de2_gym_name_too_long = /** @type {(inputs: Gym_Name_Too_LongInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Der Name darf höchstens ${i?.max} Zeichen haben.`)
};

const it_it2_gym_name_too_long = /** @type {(inputs: Gym_Name_Too_LongInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Usa un nome con meno di ${i?.max} caratteri.`)
};

/**
* | output |
* | --- |
* | "Keep the name under {max} characters." |
*
* @param {Gym_Name_Too_LongInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gym_name_too_long = /** @type {((inputs: Gym_Name_Too_LongInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gym_Name_Too_LongInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gym_name_too_long(inputs)
	if (locale === "es-419") return es_419_gym_name_too_long(inputs)
	if (locale === "pt-PT") return pt_pt2_gym_name_too_long(inputs)
	if (locale === "fr-FR") return fr_fr2_gym_name_too_long(inputs)
	if (locale === "de-DE") return de_de2_gym_name_too_long(inputs)
	if (locale === "it-IT") return it_it2_gym_name_too_long(inputs)
	return en_us2_gym_name_too_long(inputs)
});
export { gym_name_too_long as "gym.name_too_long" }